<template>
    <div class="YuChenProduct">
        <homeType text="誉诚产品" top="3" bottom="3"></homeType>
        <div class="cardBox1 onswiper">
            <div class="swiper-slide" v-for="(item, index) in topData" :key="index+20" @click="$router.push(item.url)">
                <div class="swiper_card clothes">
                    <img  :src="baseUrl + 'img/09m/YCproduct/'+ item.src" alt="" srcset="">
                    <div class="text_box">
                        <div class="clothes_img">
                            <img src="../../public/img/09m/YCproduct/logo.png" alt="" srcset="">
                        </div>
                        <div class="text_box_title">{{$t(item.title)}}</div>
                        <div class="text_box_text" v-html="$t(item.text)"></div>
                        <div class="clothes_btn">{{$t('详细了解')}}</div>
                    </div>
                </div>
            </div>         
        </div>
        <div class="cardBox1" style="margin-top:3rem;">
            <div class="left_btn" @click="cut()">
                <img src="../../public/img/09m/home/left.png" alt="" srcset="">
            </div>
            <div class="right_btn" @click="add()">
                <img src="../../public/img/09m/home/right.png" alt="" srcset="">
            </div>
            <div class="product-swiper">
                <div class="swiper-wrapper" >
                    <div class="swiper-slide" v-for="(item, index) in productList" :key="index">
                        <div class="swiper_card">
                            <img :src="item.src" alt="" srcset="">
                            <div class="text_box">
                                <div class="text_box_title">{{$t(item.title)}}</div>
                                <div class="text_box_text" v-html="$t(item.text)"></div>                                
                            </div>
                        </div>
                    </div>    
                </div>
            </div>
        </div>        
    </div>
</template>
<script>
import homeType from '../components/homeType.vue'
import Swiper from 'swiper'
export default {
    components:{
        homeType,
    },
    data() {
        return {
            baseUrl:process.env.BASE_URL, 
            topData:[
                {
                    src:'防护服.jpg',
                    title:'一次性防护服',
                    text:'医院,CDC,政府机构等可以进入医院的ICU,对病毒有抵抗力',
                    url:"/productClass_info_class?classId=1"
                },
                {
                    src:'实验服.jpg',
                    title:'实验服',
                    text:'采用优质的PP材质可作为普通防护',
                    url:"/productClass_info_class?classId=2"
                },
                {
                    src:'隔离衣.jpg',
                    title:'隔离衣',
                    text:'一次性隔离衣，采用PP材质产品远销英国、意大利、德国等海外多个国家',
                    url:"/productClass_info?productId=13&classId=3"
                }
            ],
            productList:[
                {
                    src:this.ip+'/image_product/产品大类/一次性防护口罩.jpg',
                    title:'一次性防护口罩',
                    text:'口罩由25g pp+25g熔喷布+25g pp构成过滤效率达99％(BFE≥99%)',
                    url:"/productClass_info?productId=15&classId=4"
                },{
                    src:this.ip+'/image_product/产品大类/透气膜头套.jpg',
                    title:'透气膜头套',
                    text:'55gsm透气膜头套，透气性好。具有防微生物感染、维修及维护作业、防化学喷溅、抗静电等优良性能。',
                    url:"/productClass_info_class?classId=5"
                },{
                    src:this.ip+'/image_product/产品大类/胡须套.jpg',
                    title:'胡须套',
                    text:'一次性胡须套以12g PP为原材料，经过三线机等多道工序完成。',
                    url:"/productClass_info?classId=6&productId=18"
                },{
                    src:this.ip+'/image_product/产品大类/条帽.jpg',
                    title:'条帽',
                    text:'无纺布条帽透气性强，用在一些对于环境要求严格的场所，防止头发掉落，保证环境的干净。无纺布条帽的适用范围广泛，尤其是医疗、电子、食品加工等行业。',
                    url:"/productClass_info?productId=19&classId=7"
                },{
                    src:this.ip+'/image_product/产品大类/袖套.jpg',
                    title:'袖套',
                    text:'55g透气膜袖套，具有防微生物感染、维修维护作业、防化学喷溅、抗静电等优良性能。广泛用于食品加工、包装等生活服务场所。',
                    url:"/productClass_info_class?classId=8"
                },{
                    src:this.ip+'/image_product/产品大类/靴套.jpg',
                    title:'靴套',
                    text:'誉诚塑料手套采用PP材质制作。可用于洗碗、吃食、保护等场景。具有良好的安全性、方便、经久耐用、有效隔离的特点。',
                    url:"/productClass_info_class?classId=9"
                },{
                    src:this.ip+'/image_product/产品大类/鞋套.jpg',
                    title:'鞋套',
                    text:'一次性防护靴套采用80gsm白色淋膜(PP+PE)带500gsmPVC鞋底。具有良好的透气性、抗病毒、抗静电等优良性能，防滑效果更优。',
                    url:"/productClass_info_class?classId=10"
                },{
                    src:this.ip+'/image_product/产品大类/PE塑料手套.jpg',
                    title:'PE塑料手套',
                    text:'一次性塑料鞋套是由3g CPE材质机器制成。环境不受污染的常用鞋套，广泛应用于电子、化工、无尘车间、洁净室等高要求环境。',
                    url:"/productClass_info?productId=29&classId=11"
                },
            ]
        }
    },
    mounted(){
        let _this = this
        this.mySwiper = new Swiper('.product-swiper',{
            loop:false,
            grabCursor: true,
            slidesPerView: 'auto',   //设置slider容器能够同时显示的slides数量
            paginationClickable: true,
            autoplay: true,
            // autoHeight:true,
            centeredSlides:false,
            on:{
                click:function(swiper){
                    _this.$router.push(_this.productList[swiper.clickedIndex%7].url)
                }
            },
        });
        this.timer = setInterval(()=>{
           this.mySwiper.slideNext();
        },8000)
    },
    destroyed(){
        clearInterval(this.mySwiper)
    },
    methods: {
        add(){
            this.mySwiper.slideNext();  
        },
        cut(){
            this.mySwiper.slidePrev();
        },
    },
}
</script>
<style lang="less" scoped>
@minH:60vw;
@proportion:0.96;
.YuChenProduct{
    width: 100vw;
    min-height: @minH;
    // background-color: rgba(202, 73, 73, 0.466);
    margin-top: 5vw;
    padding: 1px;
    padding-bottom: 3rem;
    background-image: url('../../public/img/09m/home/首页产品栏背景.jpg');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .left_btn{
        position: absolute;
        left: 0;
        top: 50%;
        transform: translate(-5vw,-50%);
        width: 3.5vw;
        height: 3.5vw;
        border-radius: 50%;
        background-color: #ffffff;
        box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        img{
            height: 60%;
            transform: translateX(-10%);
        }
    }
    .right_btn{
        position: absolute;
        right: 0;
        top: 50%;
        transform: translate(5vw,-50%);
        width: 3.5vw;
        height: 3.5vw;
        border-radius: 50%;
        cursor: pointer;
        background-color: #ffffff;
        box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
        display: flex;
        align-items: center;
        justify-content: center;
        img{
            height: 60%;
            transform: translateX(10%);
        }
    }
    @media screen and (min-width: 0px) and (max-width: 480px){
    // 在这里写小屏幕设备的样式
        .swiper-slide{
            width: 73vw;
            height: 73vw/@proportion;
        }
    }

    @media only screen and (min-width: 481px) and (max-width: 1024px){
    // 这里写宽度大于321px小于1024px的样式(一般是平板电脑)
       .swiper-slide{
            width: 73vw/3;
            height: 73vw/3/@proportion;
        }
    }

    @media only screen and (min-width: 1029px){
        // 这里写pc客户端的样式
        .swiper-slide{
            width: 73vw/3;
            height: 73vw/3/@proportion;
        }
    }
    .cardBox1{
        width: 73vw;
        min-height: 22vw;
        position: relative;
        // background-color: red;
        margin: 0 auto;
    }
    .clothes_btn{
        font-weight: bold;
        font-family: "YHBD";
        color: #017CA4;
        border-radius: 10vw;
        padding: 0.3vw 4vw;
        width: fit-content;
        background-color: #ffffff;
        text-align: center;
        font-size: 0.9vw;
        display: none;        
    }
    .clothes_img{
        width: 3vw;
        display: none;
        transition: all 0.3s ease-in-out;
        margin-bottom: 1vw;       
        position: relative;
        img{
            width: 100%;
            display: block;
        }
    }
    .clothes:hover{
        &::after{
            opacity: 0.6;
            background-image: linear-gradient(47deg,#007CA9 20%,#009D40 100%);
        }
        .text_box{
            display: flex;
            flex-direction: column;
            align-items: center;
            left: 50%;
            top: 50%;
            height: 80%;
            // background-color: red;
            transform: translate(-50%,-50%);
            justify-content: center;
            .clothes_btn{display: block;}
            .clothes_img{display: block;}
        }
    }
    .onswiper{
        display: flex;
        flex-wrap: wrap;
    }
    .swiper_card{
        width: 88%;
        height: 88%;
        border-radius: 8px;
        position: relative;
        overflow: hidden;
        box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.35);
        &::after{
            content: '';
            width: 100%;
            height: 100% + 1px;
            position: absolute;
            left: 0px;
            top: 0px;
            z-index: 1;
            // opacity: 1;
            // transition: 0.4s all ease-in-out;
            background-image: linear-gradient(rgba(0,175,64,0) 40%,rgba(0,175,64,0.2),rgba(0,124,169,1) 100%);
        }
        img{
            width: 100%;
            height: 100%;
        }
        .text_box{
            z-index: 2;
            width: 80%;
            position: absolute;
            left: 50%;
            transform: translate(-50%,0);
            bottom: 0;
            .text_box_title{
                color: #ffffff;
                font-weight: bold;
                text-align: center;
                transition: all 0.3s ease-in-out;        
            }
            .text_box_text{
                color: #ffffff;;
                text-align: center;
                margin-bottom: 1rem;
                font-size: 0.6rem;
                margin-top: 1rem;
                line-height: 1rem;
                height: 2rem;
                overflow: hidden;/*超出部分隐藏*/
                text-overflow:ellipsis;/* 超出部分显示省略号 */
                transition: all 0.3s ease-in-out;                
            }
        }
    }
    .product-swiper{
        width: 100%;
        min-height: 100%;
        overflow: hidden;
        // background-color: green;
    }
    .swiper-slide{
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
}
</style>
<i18n>
{
    "en":{
        "详细了解":"More",
        "一次性防护服":"Disposable Coverall",
        "隔离衣":"Disposable Isolation Gown",        
        "实验服":"Disposable Lab Coat",
        "医院,CDC,政府机构等可以进入医院的ICU,对病毒有抵抗力":"Hospitals, CDCs, government agencies, etc. can enter the ICU of the hospital and are resistant to viruses.",
        "采用优质的PP材质可作为普通防护":"Disposable overalls, made of high-quality PP material.",
        "一次性隔离衣，采用PP材质产品远销英国、意大利、德国等海外多个国家":"Disposable isolation gowns made of PP are exported to many overseas countries such as Britain, Italy and Germany.",
        "口罩由25g pp+25g熔喷布+25g pp构成过滤效率达99％(BFE≥99%)":"Yucheng disposable protective mask is composed of 25g PP+25g meltblown cloth+25g PP, with a filtration efficiency of 99% to effectively isolate harmful particles from the outside world",
        "55gsm透气膜头套，透气性好。具有防微生物感染、维修及维护作业、防化学喷溅、抗静电等优良性能。":"55gsm breathable film headgear, good breathability. It has excellent properties such as anti-microbial infection, repair and maintenance operations, anti-chemical splashing, and anti-static.",
        "一次性胡须套以12g PP为原材料，经过三线机等多道工序完成。":"The disposable beard cover is made of 12g PP as the raw material, and is completed through multiple processes such as a three-line machine",
        "无纺布条帽透气性强，用在一些对于环境要求严格的场所，防止头发掉落，保证环境的干净。无纺布条帽的适用范围广泛，尤其是医疗、电子、食品加工等行业。":"Non-woven fabric caps are highly breathable and are used in places with strict environmental requirements to prevent hair from falling and ensure a clean environment.",
        "55g透气膜袖套，具有防微生物感染、维修维护作业、防化学喷溅、抗静电等优良性能。广泛用于食品加工、包装等生活服务场所。":"The 55g breathable film sleeve has excellent properties such as anti-microbial infection, repair and maintenance operations, anti-chemical splash, and anti-static. It is widely used in life service places such as food processing and packaging.",
        "誉诚塑料手套采用PP材质制作。可用于洗碗、吃食、保护等场景。具有良好的安全性、方便、经久耐用、有效隔离的特点。":"Disposable plastic shoe covers are made of 3g CPE material machine. Common shoe covers that are not polluted in the environment are widely used in high-demand environments such as electronics, chemicals, dust-free workshops, and clean rooms.",
        "一次性防护靴套采用80gsm白色淋膜(PP+PE)带500gsmPVC鞋底。具有良好的透气性、抗病毒、抗静电等优良性能，防滑效果更优。":"Yucheng plastic gloves are made of PP. It can be used in scenes such as washing dishes, eating and protecting. It has the characteristics of good safety, convenience, durability and effective isolation.",
        "一次性塑料鞋套是由3g CPE材质机器制成。环境不受污染的常用鞋套，广泛应用于电子、化工、无尘车间、洁净室等高要求环境。":"The disposable protective boot cover is made of 80gsm white coating (PP+PE) with 500gsm PVC sole. It has good air permeability, anti-virus and anti-static properties, and has a better anti-slip effect."
    },
    "zh":{
        "详细了解":"详细了解",
        "一次性防护服":"一次性防护服",
        "隔离衣":"隔离衣",        
        "实验服":"实验服",
        "医院,CDC,政府机构等可以进入医院的ICU,对病毒有抵抗力":"誉诚的防护服量多质好<br>在仙桃防护服生产中遥遥领先",
        "采用优质的PP材质可作为普通防护":"采用优质的PP材质<br>可作为普通防护",
        "一次性隔离衣，采用PP材质产品远销英国、意大利、德国等海外多个国家":"一次性隔离衣，采用PP材质<br>产品远销英国、意大利、德国等海外多个国家",
        "口罩由25g pp+25g熔喷布+25g pp构成过滤效率达99％(BFE≥99%)":"口罩由25g pp+25g熔喷布+25g pp构成<br>过滤效率达99％(BFE≥99%)",
        "55gsm透气膜头套，透气性好。具有防微生物感染、维修及维护作业、防化学喷溅、抗静电等优良性能。":"55gsm透气膜头套，透气性好<br>防微生物感染、防化学喷溅、抗静电",
        "一次性胡须套以12g PP为原材料，经过三线机等多道工序完成。":"一次性胡须套以12g PP为原材料<br>经过三线机等多道工序完成",
        "无纺布条帽透气性强，用在一些对于环境要求严格的场所，防止头发掉落，保证环境的干净。无纺布条帽的适用范围广泛，尤其是医疗、电子、食品加工等行业。":"无纺布条帽透气性强<br>用在一些对于环境要求严格的场所",
        "55g透气膜袖套，具有防微生物感染、维修维护作业、防化学喷溅、抗静电等优良性能。广泛用于食品加工、包装等生活服务场所。":"55g透气膜袖套，具有防微生物感染<br>广泛用于食品加工、包装等生活服务场所",
        "誉诚塑料手套采用PP材质制作。可用于洗碗、吃食、保护等场景。具有良好的安全性、方便、经久耐用、有效隔离的特点。":"一次性防护靴套具有良好的透气性、<br>抗病毒、抗静电等优良性能、防滑效果更优",
        "一次性防护靴套采用80gsm白色淋膜(PP+PE)带500gsmPVC鞋底。具有良好的透气性、抗病毒、抗静电等优良性能，防滑效果更优。":"一次性鞋套具有良好的透气性、<br>抗病毒、抗静电等优良性能、防滑效果更优",
        "一次性塑料鞋套是由3g CPE材质机器制成。环境不受污染的常用鞋套，广泛应用于电子、化工、无尘车间、洁净室等高要求环境。":"一次性塑料鞋套是由3g CPE材质机器制成。环境不受污染的常用鞋套，广泛应用于电子、化工、无尘车间、洁净室等高要求环境。"
    }
}
</i18n>
